module.exports = __webpack_public_path__ + "static/media/x.7be246d4.svg";